export default __webpack_public_path__ + "static/media/circ3dufo.0a919436.jpg";